import { createRoot } from "react-dom/client";

import { App } from "./components/App";
import { currentPlatform } from "./currentPlatform";
import { RootStore } from "./stores/RootStore";
import { StoresContext } from "./stores/useStores";
import { CurrentTheme } from "./theme/CurrentTheme";

const platform = currentPlatform();
const stores = new RootStore(platform.storage);

platform.onLibraryChange(() => void stores.sync());

// Ask the browser not to clear the library when it runs low on space. Everything lives on the device.
void navigator.storage?.persist?.();
void stores.library.load();

// While signed in, fetch the settings saved from other devices when the app opens, and when it comes back into view.
void stores.account.refresh().then(() => stores.settingsSync.sync());
document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && void stores.settingsSync.sync());

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    void navigator.serviceWorker.register("sw.js");
}

createRoot(document.getElementById("root")!).render(
    <StoresContext.Provider value={stores}>
        <CurrentTheme />
        <App />
    </StoresContext.Provider>,
);
